export const VALID_MATERIAL_CODE = '12345'

export const MATERIAL_BY_CODE = {
  [VALID_MATERIAL_CODE]: {
    id: 'custom-12345',
    codigo: VALID_MATERIAL_CODE,
    nombre: 'Gato Auxiliar Reforzado',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$128.500',
    imagen:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSr6QHlLLqE6yHXiegKPlKxIH6g0tms3PZIyx5dH924LA&s=10',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 36, B: 13, C: 9 },
    isCustom: true,
  },
}

export const MOCK_RESULTS = [
  'Material 111 - Gato central',
  'Material 111 - Gato lateral',
  'Material 111 - soporte Gato lateral',
  'Material 111 - Kym gato lateral',
]

export const DEMO_TERMS = ['gato', 'pata']

export const REPLACEMENT_PRODUCTS = [
  {
    id: 2231,
    nombre: 'Gato Lateral',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$120.000',
    imagen:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSr6QHlLLqE6yHXiegKPlKxIH6g0tms3PZIyx5dH924LA&s=10',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 34, B: 12, C: 9 },
  },
  {
    id: 562,
    nombre: 'Gato Central',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$135.000',
    imagen: 'https://gxmotor.co/cdn/shop/files/56904.jpg?v=1758630212',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 38, B: 14, C: 10 },
  },
  {
    id: 9376,
    nombre: 'Gato Trasero',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$118.000',
    imagen:
      'https://http2.mlstatic.com/D_NQ_NP_2X_942714-MCO102776518028_012026-T.webp',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 32, B: 11, C: 8 },
  },
  {
    id: 9377,
    nombre: 'Gato Lateral Derecho',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$122.000',
    imagen:
      'https://yamaha.vtexassets.com/arquivos/ids/179819-800-auto?v=638321181296100000&width=800&height=auto&aspect=true',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 34, B: 12, C: 9 },
  },
  {
    id: 2145,
    nombre: 'Gato Plegable',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$145.000',
    imagen:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSO954hwltgEq4Fnwuku-SPDbXs0s7CRzlTNPAoBXfHdNHeN8m0mBJoUGxx&s=10',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 40, B: 15, C: 11 },
  },
  {
    id: 1254,
    nombre: 'Gato de Pie',
    marca: 'Ceronte',
    categoria: 'Parte apariencia',
    subcategoria: 'Gato',
    costo: '$110.000',
    imagen:
      'https://http2.mlstatic.com/D_NQ_NP_2X_942714-MCO102776518028_012026-T.webp',
    proveedor: 'KYMCO KWANG YANG MOTOR CO LTD',
    medidas: { A: 30, B: 10, C: 8 },
  },
]

export const REFERENCE_BY_BUTTON = {
  'Material 111 - Gato central': REPLACEMENT_PRODUCTS[1],
  'Material 111 - Gato lateral': REPLACEMENT_PRODUCTS[0],
  'Material 111 - soporte Gato lateral': {
    ...REPLACEMENT_PRODUCTS[0],
    id: 'ref-soporte',
    nombre: 'Soporte Gato Lateral',
    costo: '$98.000',
    medidas: { A: 28, B: 10, C: 7 },
  },
  'Material 111 - Kym gato lateral': REPLACEMENT_PRODUCTS[3],
}

export const getReplacementProducts = (referenceProduct, customProducts = []) => {
  const base = REPLACEMENT_PRODUCTS.filter(
    (product) => product.id !== referenceProduct.id,
  )
  return [...base, ...customProducts]
}

export const getPairKey = (idA, idB) => [idA, idB].sort().join('|')

export const isPairMatched = (idA, idB, matchedPairs) =>
  matchedPairs.some(
    (pair) => getPairKey(pair[0], pair[1]) === getPairKey(idA, idB),
  )

export const isProductInAnyMatch = (productId, matchedPairs) =>
  matchedPairs.some((pair) => pair.includes(productId))

export const getProductNombre = (productId, products) =>
  products.find((product) => product.id === productId)?.nombre ?? productId

// Imagen de respaldo cuando el material no trae foto (la API RAG no la incluye)
export const PLACEHOLDER_IMG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='96'%3E%3Crect width='100%25' height='100%25' fill='%23f1f5f9'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='11' fill='%2394a3b8'%3ESin imagen%3C/text%3E%3C/svg%3E"

// Mapea un resultado del buscador RAG al formato de material que usa la UI.
// La API entrega: content, contextMetadata{...}, distance, similarityPct.
export const mapRagResultToProduct = (result) => {
  const meta = result?.contextMetadata ?? {}
  const specs = meta.specifications ?? {}
  const similarityPct =
    typeof result?.similarityPct === 'number'
      ? Math.round(result.similarityPct)
      : null

  return {
    id: meta.productId ?? meta.sku ?? meta.npfCode,
    sku: meta.sku ?? '',
    npf: meta.npfCode ?? '—',
    nombre: meta.commercialName || meta.name || 'Sin nombre',
    marca: meta.brand || '—',
    categoria: meta.category || specs.family || '—',
    subcategoria: specs.type || specs.model || '—',
    costo: '—',
    imagen: '',
    proveedor: '—',
    medidas: null,
    similarityPct,
    content: result?.content ?? '',
  }
}
